export class HistoryDto {
  createdDate?: string;
  createdBy?: string;
  modifiedDate?: string;
  modifiedBy?: string;
  auditSource: string;
  reason: string;

  constructor(d?: HistoryDto) {
    if (!d) {
      return;
    }
    this.createdDate = d.createdDate;
    this.createdBy = d.createdBy;
    this.modifiedDate = d.modifiedDate;
    this.modifiedBy = d.modifiedBy;
    this.auditSource = d.auditSource;
    this.reason = d.reason;
  }
}
